export const helpCenterUrl = "https://docs.onewateryun.online";

export const landingPageUrl = "https://app.onewateryun.online";
export const quickStartTutorialUrl =
  "https://docs.onewateryun.online/quick-start";
export const sourceCodeUrl = "https://gitee.com/";
export const newsletterUrl =
  //"https://mastering-water-models.kit.com/e9c8f66e11";
  "https://docs.onewateryun.online/intro";
export const privacyPolicyUrl = "https://docs.onewateryun.online/intro";
export const termsAndConditionsUrl = "https://docs.onewateryun.online/intro";
export const projectionConverterUrl =
  //"https://utils.epanetjs.com/projection-converter";
  "https://docs.onewateryun.online/intro";
export const studentAccountActiviationHelpUrl =
  //"https://help.epanetjs.com/Free-educational-licenses-for-epanet-js-1cee18c9f0f68090aa35cd3336577ac3";
  "https://docs.onewateryun.online/intro";
export const supportEmail = "support@onewateryun.com";

export const signInUrl = process.env.NEXT_PUBLIC_CLERK_SIGN_IN_URL as string;
export const signUpUrl = process.env.NEXT_PUBLIC_CLERK_SIGN_UP_URL as string;

export const pingUrl = process.env.NEXT_PUBLIC_PING_URL || "/ping.txt";

// console.log('signUpUrl from global-config:', signUpUrl); // 临时调试
